"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormField = void 0;
var react_1 = __importDefault(require("react"));
var FormField_module_scss_1 = __importDefault(require("./FormField.module.scss"));
var FormField = function (props) {
    var id = props.id, placeholder = props.placeholder, register = props.register, isError = props.isError;
    return (react_1.default.createElement("label", { className: FormField_module_scss_1.default.form_field, htmlFor: id },
        react_1.default.createElement("input", __assign({ autoComplete: "off" }, register, { className: "".concat(FormField_module_scss_1.default.form_field__input, " ").concat(isError ? 'field_error' : ''), id: id, type: "text", placeholder: placeholder }))));
};
exports.FormField = FormField;
